export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-searchbar/index.js